import { useUsersGetMyAlerts } from '@api/WhisApi/generated';

export const useUnreadNotifications = (): boolean => {
  const { data } = useUsersGetMyAlerts({
    query: {
      gcTime: 5 * 60 * 1000, // Notification data must be maximum 5min old
    },
  });
  return data?.alerts.some((notification) => !notification.read) ?? false;
};
